import { useMutation } from "@tanstack/react-query";
import { useEffect, useRef } from "react";
import { useSMSFormState } from "./useSMSFormState";
import { ESMSFormState } from "../../../../../store/slices/smsFormSliceCreator";
import { NetworkError, otpVerificationMutationFn } from "../../../../../api";
import { useToast } from "@chakra-ui/react";
import { SMS_FORM_ERROR_MESSAGES } from "./useSMSFormStateReaction";
import { usePersistStore } from "../../../../../store/persistStore";
import { useNavigate } from "react-router-dom";
import { RoutesMap } from "../../../../../routes.tsx";

const toastId = "verification-mutation";

/**
 * Uses the OTP verification mutation reaction to verify the user's OTP code.
 */
export function useOTPVerificationMutationReaction() {
  const toast = useToast();
  const navigate = useNavigate();
  const redirectedRef = useRef(false);
  const smsFormState = useSMSFormState();
  const setJWT = usePersistStore(state => state.setJwt);

  const status = useMutation({
    mutationFn: otpVerificationMutationFn,
    mutationKey: ["otpVerification"],
  });

  useEffect(() => {
    switch (status.status) {
      case "success": {
        smsFormState.setFormState(ESMSFormState.submitted);
        const response = status.data as { token: string };
        setJWT(response.token);
        // navigate(RoutesMap.login.loading,);
        navigate(RoutesMap.login.pin, { replace: true });
        return;
      }
      case "error": {
        const error = status.error as NetworkError;
        switch (error.internalCode) {
          // 1100 - invalid code and 7000 too
          case 7000:
          case 1100: {
            smsFormState.setErrorMessage(SMS_FORM_ERROR_MESSAGES.incorrect);
            smsFormState.setFormState(ESMSFormState.initial);
            return;
          }
          // 4601 - passport required
          case 4601: {
            if (!redirectedRef.current) {
              redirectedRef.current = true;
              smsFormState.setFormState(ESMSFormState.initial);
              smsFormState.setErrorMessage("");
              navigate(RoutesMap.login.passport, { replace: true, state: { reason: "passport_required", from: "login/otp" } });
            }
            return;
          }
        }
        // status code is not 456 or unexpected internal code
        toast({
          id: toastId,
          description: SMS_FORM_ERROR_MESSAGES.unexpectedServerError,
        });
        smsFormState.setFormState(ESMSFormState.initial);
        return;
      }
    }
  }, [status.status]);

  return status;
}
